import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { CommunityPost } from '../models/app.models';
import { environment } from '../../environments/environment';

interface CommunityPostApi {
  id: number;
  title: string;
  date: string;
  description: string;
  link: string | null;
  imageId: number | null;
}

interface CommunityPostRequest {
  title: string;
  date: string;
  description: string;
  link: string | null;
  imageId: number | null;
}

@Injectable({
  providedIn: 'root'
})
export class CommunityPostService {
  private readonly apiUrl = environment.apiUrl+'/communityposts';
  private readonly mediaUrl = environment.apiUrl+'/media';

  constructor(private readonly http: HttpClient) {}

  getPosts(): Observable<CommunityPost[]> {
    return this.http
      .get<CommunityPostApi[]>(this.apiUrl, {
        withCredentials: true
      })
      .pipe(
        map(posts => posts.map(post => this.fromApi(post)))
      );
  }
  getAdminPosts(): Observable<CommunityPost[]> {
    return this.http
      .get<CommunityPostApi[]>(this.apiUrl +'/admin', {
        withCredentials: true
      })
      .pipe(
        map(posts => posts.map(post => this.fromApi(post)))
      );
  }

  createPost(post: CommunityPost): Observable<CommunityPost> {
    return this.http
      .post<CommunityPostApi>(
        this.apiUrl,
        this.toRequest(post),
        { withCredentials: true }
      )
      .pipe(
        map(savedPost => this.fromApi(savedPost))
      );
  }

  updatePost(post: CommunityPost): Observable<void> {
    return this.http.put<void>(
      `${this.apiUrl}/${post.id}`,
      this.toRequest(post),
      { withCredentials: true }
    );
  }

  deletePost(id: number): Observable<void> {
    return this.http.delete<void>(
      `${this.apiUrl}/${id}`,
      { withCredentials: true }
    );
  }

  private fromApi(post: CommunityPostApi): CommunityPost {
    return {
      id: post.id,
      title: post.title,

      // ASP.NET returns DateTime values with a time component.
      // The Admin <input type="date"> only wants YYYY-MM-DD.
      date: post.date.slice(0, 10),

      description: post.description,
      link: post.link ?? '',
      imageId: post.imageId,

      // Existing Admin HTML can keep using imageUrl.
      imageUrl: post.imageId
        ? `${this.mediaUrl}/${post.imageId}`
        : ''
    };
  }

  private toRequest(post: CommunityPost): CommunityPostRequest {
    return {
      title: post.title,
      date: `${post.date}T00:00:00`,
      description: post.description,
      link: post.link.trim() || null,
      imageId: post.imageId
    };
  }
}